module.exports = __webpack_public_path__ + "static/n-l5-hero-image-9f2058eb683086283f2f2e76056890c1.png";